import { useClickAway } from '@ipfabric/ui-components/hooks/useClickAway';
import { SearchIcon } from 'components/icons/SearchIcon';
import { useLocale } from 'containers/App/LocaleContext';
import { useState } from 'react';
import type { FC } from 'react';
import { GraphToolbarButton } from './GraphToolbarButton';
import { GraphToolbarSearchForm } from './GraphToolbarSearchForm';

interface Props {
  disabled: boolean;
}

export const GraphToolbarSearch: FC<Props> = (props) => {
  const {
    canvasGraph: {
      graphToolbar: { buttons: msgButtons },
    },
  } = useLocale();
  const [open, setOpen] = useState<boolean>(false);
  const [value, setValue] = useState<string>('');

  const toggleOpen = () => {
    if (!(open && value !== '')) {
      setOpen(!open);
    }
  };

  const handleClose = () => {
    if (value === '') {
      setOpen(false);
    }
  };

  const wrapperRef = useClickAway<HTMLDivElement>(handleClose);

  return (
    <div className='relative' ref={wrapperRef}>
      {open && (
        <GraphToolbarSearchForm
          onClose={handleClose}
          value={value}
          setValue={setValue}
        />
      )}
      <GraphToolbarButton
        disabled={props.disabled}
        disabledTitle={msgButtons.selectDataToDisplay}
        onClick={toggleOpen}
        title={msgButtons.searchDiagram}
      >
        <SearchIcon title='Search' height={16} width={16} />
      </GraphToolbarButton>
    </div>
  );
};
